import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";

export default function CctvSurveillance() {
  return (
    <div className="Cctv-Surveillance pt-[160px] sm:pt-0">
       <Helmet>
        <title>Top-Rated CCTV Surveillance Services | Mean3</title>
        <meta
        name="description"
        content="Protect your property with Mean3’s CCTV surveillance services. Get top-notch security solutions. Contact us now to secure your space!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </div>
  );
}
